import "../styles/general.css";

import axios from "axios";
import Info from "../components/info/Info";

import uppdateKMs from "../utils/uppdateKMs";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
// import { sigments } from "../constants/sigments";
import { SHOW_PIECES } from "../constants/piecesIcon";
import globalContext from "../Contexts/GlobalContext";
import BlueLoader from "../components/loader/BlueLoader";
import MessageModals from "../components/modals/MessageModals";
import InformationModal from "../components/modals/InformationModal";
import CarDetailsBox from "../components/cardetailsbox/CarDetailsBox";
import ChangeKmModal from "../components/changeKmModal/ChangeKmModal";
import DesktopView from "../components/desktopview/DesktopView";

import React, { useContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import {
  SIGMENT_BOX_LEFT_BLUE,
  SIGMENT_BOX_LEFT_YELLOW,
  SIGMENT_BOX_RIGHT_BLUE,
  SIGMENT_BOX_RIGHT_YELLOW,
} from "../constants/sigmentsBox";
import { sigments } from "../constants/sigments";
import { PIECES_TITLE } from "../constants/pieces";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import useRequestHeader from "../hooks/useRequestHeader";

export default function ShortTerms() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;

  const navigate = useNavigate();
  const contextData = useContext(globalContext);
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const requestHeader = useRequestHeader();

  //// ref passes start  ////
  const [logoUrl, setLogoUrl] = useState("");
  const [kmCurrent, setKmCurrent] = useState("");
  //// ref passes end ////

  const bodyRef = useRef();
  const headerRef = useRef();
  const footerRef = useRef();

  //// 8 box precentage section start ////
  const [cabinFilterPercent, setCabinFilterPercent] = useState(0);
  const [engineFilterPercent, setEngineFilterPercent] = useState(0);
  const [oilFilterPercent, setOilFilterPercent] = useState(0);
  const [engineOilPercent, setEngineOilPercent] = useState(0);
  const [radiatorPercent, setRadiatorPercent] = useState(0);
  const [saltGlassPercent, setSaltGlassPercent] = useState(0);
  const [batteryPercent, setBatteryPercent] = useState(0);
  const [fuelFilterPercent, setFuelFilterPercent] = useState(0);
  //// 8 box precentage section end ////

  const titleRef = useRef();
  const pb = useRef();

  //// useeffect for get percents star  ////
  //// loading percents bool start ////
  const [isLoadingPercents, setIsLoadingPercents] = useState(false);
  //// loading percents bool end ////
  useEffect(() => {
    if (!contextData?.changeKmModalIsOpen) {
      setIsLoadingPercents(true);
      const config = {
        headers: requestHeader,
      };
      axios
        .post(
          `${BASE_URL}/car/carInfo`,
          {
            plate: cookies?.plate,
          },
          config
        )
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          setIsLoadingPercents(false);
          setLoadApiEnd(true);
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              contextData.setToggleNewCar((prev) => !prev);
              setCookies("carID", res?.data?.Data?.carID);
              let shoetErr = 8;
              if (res?.data?.Data?.info?.["percent-short"]) {
                shoetErr -= res?.data?.Data?.info["percent-short"].length;
              }
              if (res?.data?.Data?.info?.["percent-short"]) {
                res?.data?.Data?.info["percent-short"].map((item) => {
                  setCookies(item.pieceName, item.percent);
                  if (item.percent <= 10) {
                    shoetErr++;
                  }
                });
                uppdateKMs(
                  res?.data?.Data?.info,
                  setEngineOilPercent,
                  setOilFilterPercent,
                  setEngineFilterPercent,
                  setCabinFilterPercent,
                  setFuelFilterPercent,
                  setSaltGlassPercent,
                  setRadiatorPercent,
                  setBatteryPercent
                );
              }
              contextData.setShortErrors(shoetErr);
              let midErr = 8;
              if (res?.data?.Data?.info?.["percent-middle"]) {
                midErr -= res?.data?.Data?.info["percent-middle"].length;
              }
              if (res?.data?.Data?.info?.["percent-middle"]) {
                res?.data?.Data?.info["percent-middle"].map((item) => {
                  setCookies(item.pieceName, item.percent);
                  if (item.percent <= 10) {
                    midErr++;
                  }
                });
              }
              contextData.setMidErrors(midErr);

              let longErr = 8;
              if (res?.data?.Data?.info?.["percent-long"]) {
                longErr -= res?.data?.Data?.info["percent-long"].length;
              }

              if (res?.data?.Data?.info?.["percent-long"]) {
                res?.data?.Data?.info["percent-long"].map((item) => {
                  setCookies(item.pieceName, item.percent);
                  if (item.percent <= 10) {
                    longErr++;
                  }
                });
              }
              contextData.setLongErrors(longErr);
              setLogoUrl(res?.data?.Data?.srcLogo);
              setKmCurrent(
                res?.data?.Data?.kmCurrent ? res?.data?.Data?.kmCurrent : 0
              );
              setCookies("logoUrlPices", res?.data?.Data?.srcLogo, {
                path: "/",
              });
              setCookies(
                "kmCurrent",
                res?.data?.Data?.kmCurrent ? res?.data?.Data?.kmCurrent : 0,
                { path: "/" }
              );
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
        })
        .catch((err) => {
          setLoadApiEnd(true);
          setIsLoadingPercents(false);
        });
    }
  }, [contextData?.changeKmModalKM, cookies?.kmCurrent]);
  //// useeffect for get percents end  ////
  useEffect(() => {
    if (contextData?.isRepairAdd) {
      contextData?.setChangeKmModalKM(kmCurrent);
    }
  }, [kmCurrent]);

  //// useeffect for history control start ////
  const [oilFilterPercent2, setOilFilterPercent2] = useState(0);
  const [engineOilPercent2, setEngineOilPercent2] = useState(0);
  const [cabinFilterPercent2, setCabinFilterPercent2] = useState(0);
  const [engineFilterPercent2, setEngineFilterPercent2] = useState(0);

  const [saltGlassPercent2, setSaltGlassPercent2] = useState(0);
  const [fuelFilterPercent2, setFuelFilterPercent2] = useState(0);
  const [batteryPercent2, setBatteryPercent2] = useState(0);
  const [radiatorPercent2, setRadiatorPercent2] = useState(0);
  ////----->
  const [loadApiEnd, setLoadApiEnd] = useState(false);
  //  ---->
  const [loadType_1, setLoadType_1] = useState(true);
  const [loadType_2, setLoadType_2] = useState(true);
  const [loadType_3, setLoadType_3] = useState(true);
  const [loadType_4, setLoadType_4] = useState(true);
  const [loadType_5, setLoadType_5] = useState(true);
  const [loadType_6, setLoadType_6] = useState(true);
  const [loadType_7, setLoadType_7] = useState(true);
  const [loadType_8, setLoadType_8] = useState(true);
  useEffect(() => {
    if (loadApiEnd) {
      TIMERANIM(
        setOilFilterPercent2,
        oilFilterPercent2,
        oilFilterPercent,
        loadType_1,
        setLoadType_1
      );
      TIMERANIM(
        setEngineOilPercent2,
        engineOilPercent2,
        engineOilPercent,
        loadType_2,
        setLoadType_2
      );
      TIMERANIM(
        setCabinFilterPercent2,
        cabinFilterPercent2,
        cabinFilterPercent,
        loadType_3,
        setLoadType_3
      );
      TIMERANIM(
        setEngineFilterPercent2,
        engineFilterPercent2,
        engineFilterPercent,
        loadType_4,
        setLoadType_4
      );
      TIMERANIM(
        setSaltGlassPercent2,
        saltGlassPercent2,
        saltGlassPercent,
        loadType_5,
        setLoadType_5
      );
      TIMERANIM(
        setFuelFilterPercent2,
        fuelFilterPercent2,
        fuelFilterPercent,
        loadType_6,
        setLoadType_6
      );
      TIMERANIM(
        setBatteryPercent2,
        batteryPercent2,
        batteryPercent,
        loadType_7,
        setLoadType_7
      );
      TIMERANIM(
        setRadiatorPercent2,
        radiatorPercent2,
        radiatorPercent,
        loadType_8,
        setLoadType_8
      );
    }
  }, [
    oilFilterPercent2,
    engineOilPercent2,
    cabinFilterPercent2,
    engineFilterPercent2,
    saltGlassPercent2,
    fuelFilterPercent2,
    batteryPercent2,
    radiatorPercent2,
    loadApiEnd,
  ]);

  function TIMERANIM(Valiable, Count, CountMemory, bol, setBol) {
    let i = 8;
    let timer = 10;
    if (Count > 50 && bol) {
      timer += Count / 4;
    } else if (!bol) {
      i = 4;
      timer = 50;
    }
    function SET(Number) {
      Valiable(Number);
    }
    setTimeout(() => {
      if (bol) {
        if (Count + i < 100) {
          SET(Count + i);
        } else {
          SET(100);
          setBol(false);
        }
      }
      if (!bol) {
        if (Count - i > CountMemory) {
          SET(Count - i);
        } else {
          SET(CountMemory);
        }
      }
    }, timer);
  }

  const [SMFMethod, setSMFMethod] = useState(false);

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className=" w-full overflow-auto min-[1024px]:hidden ">
        {contextData?.isInfoOpen && (
          <Info
            infoText={`کاربر عزیز تمامی اقلام مصرفی و قطعات خودرو در 3 دسته کوتاه مدت، میان مدت و بلند مدت در پایین صفحه قابل دسترسی شما می‌باشد \n که برای هر کدام میزان درصد عمر باقی‌مانده نمایش داده می‌شود و شما می‌تواند بعد از هر سرویس، کیلومتر تعویض هر یک از قطعات را ویرایش ‌نمایید.کیلومتر فعلی خودرو در قسمت بالا قرار داده شده است که می‌توانید با انتخاب، آن را ویرایش نمایید، همچنین با انتخاب نمودن لوگو خودرو، می‌تواند مشخصات آن را مشاهده نمایید. `}
          />
        )}
        <img
          src="../assets/images/body/body-bgimg.png"
          alt=""
          className="absolute w-full h-full top-0 right-0 -z-50"
        />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}
        {contextData?.isRepairAdd && (
          <InformationModal
            message={contextData?.repairAddMessage}
            mode={"repairAdd"}
            setSMFMethod={setSMFMethod}
          />
        )}
        {contextData?.isFirstCar && contextData?.isAfterAdd && (
          <InformationModal
            message={
              "سامانه هوشمند اسکارپین با رویکرد دو کاربره طراحی شده است؛ به‌طوری‌که کاربر اصلی مالکان وسائل نقلیه و کاربر متقابل آنها سرویس کاران می‌باشند. باتوجه به آنکه اطلاعات آخرین سرویس تمامی قطعات خودرو شما در دسترس نیست، این سامانه با در نظر گرفتن کیلومتر پیمایش فعلی خودرو و میزان کارکرد قطعات و با استفاده از یک الگوریتم، درصد باقی مانده هر یک از قطعات و اقلام مصرفی خودرو را محاسبه و نمایش می‌دهد. به‌منظور نمایش دقیق درصدهاي باقی مانده قطعات، کیلومتر تعویض هر قطعه را ثبت نمایید."
            }
            mode={"first"}
            setSMFMethod={setSMFMethod}
          />
        )}
        <Header forwardRef={headerRef} />

        {contextData?.changeKmModalIsOpen && (
          <ChangeKmModal SMFMethod={SMFMethod} />
        )}
        <div
          ref={bodyRef}
          className="w-full mt-[1.8vw] flex flex-col justify-evenly"
        >
          <CarDetailsBox
            logoUrl={logoUrl}
            setLogoUrl={setLogoUrl}
            kmCurrent={kmCurrent}
            setKmCurrent={setKmCurrent}
            forwardRef={titleRef}
          />
          <div className="absolute flex flex-col top-[36.5vw] bottom-[21vw] justify-between right-0 left-0 overflow-auto my-[3.7vw]">
            <div
              ref={pb}
              className="flex items-center justify-between px-[3.773495908115375vw] pb-[0.5vw] "
            >
              {/* /// oil filter section start /// */}
              <div
                className="relative "
                onClick={(e) => {
                  navigate(`/piece-details/${oilFilterPercent}_oil-filter`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_1 && oilFilterPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] right-[1.5vw]`}
                >
                  {PIECES_TITLE["oil-filter"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_1
                      ? "bg-color-primary-D"
                      : oilFilterPercent2 <= 10
                      ? `${loadType_1 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_1 && oilFilterPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("oil-filter", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("oil-filter", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_1 && oilFilterPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                <div
                  className={`absolute top-0 left-0 w-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(oilFilterPercent2)}
                </div>

                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} left={23} />
                )}

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      oilFilterPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {oilFilterPercent2 < 10
                      ? `0${oilFilterPercent2}`
                      : `${oilFilterPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// oil filter section end /// */}

              {/* /// engine oil  section start /// */}
              <div
                className="relative "
                onClick={(e) => {
                  navigate(`/piece-details/${engineOilPercent}_oil-motor`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_2 && engineOilPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[1.5vw]`}
                >
                  {PIECES_TITLE["oil-motor"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_2
                      ? "bg-color-primary-D"
                      : engineOilPercent2 <= 10
                      ? `${loadType_2 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_2 && engineOilPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("oil-motor", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("oil-motor", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_2 && engineOilPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(engineOilPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} right={22} />
                )}
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      engineOilPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {engineOilPercent2 < 10
                      ? `0${engineOilPercent2}`
                      : `${engineOilPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// engine oil  section end /// */}
            </div>
            <div className="flex items-center justify-between px-[3.773495908115375vw] py-[0.5vw]">
              {/* /// cabin filter  section start /// */}
              <div
                className="relative"
                onClick={(e) => {
                  navigate(`/piece-details/${cabinFilterPercent}_filter-room`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_3 && cabinFilterPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] right-[1.5vw]`}
                >
                  {PIECES_TITLE["filter-room"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_3
                      ? "bg-color-primary-D"
                      : cabinFilterPercent2 <= 10
                      ? `${loadType_3 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_3 && cabinFilterPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("filter-room", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("filter-room", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_3 && cabinFilterPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(cabinFilterPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} left={23} />
                )}

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      cabinFilterPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {cabinFilterPercent2 < 10
                      ? `0${cabinFilterPercent2}`
                      : `${cabinFilterPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// cabin filter  section end /// */}
              {/* /// engine filter  section start /// */}
              <div
                className="relative "
                onClick={(e) => {
                  navigate(
                    `/piece-details/${engineFilterPercent}_filter-motor`
                  );
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_4 && engineFilterPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[1.5vw]`}
                >
                  {PIECES_TITLE["filter-motor"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_4
                      ? "bg-color-primary-D"
                      : engineFilterPercent2 <= 10
                      ? `${loadType_4 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  }  `}
                ></div>
                {!loadType_4 && engineFilterPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("filter-motor", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("filter-motor", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_4 && engineFilterPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(engineFilterPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} right={22} />
                )}
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw] top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  } `}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      engineFilterPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {engineFilterPercent2 < 10
                      ? `0${engineFilterPercent2}`
                      : `${engineFilterPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// engine filter  section end /// */}
            </div>
            <div className="flex items-center justify-between px-[3.773495908115375vw] py-[0.5vw]">
              {/* /// salt glass  section start /// */}
              <div
                className="relative"
                onClick={(e) => {
                  navigate(`/piece-details/${saltGlassPercent}_glassCleaner`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_5 && saltGlassPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] right-[1.5vw]`}
                >
                  {PIECES_TITLE["glassCleaner"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw] ${
                    loadType_5
                      ? "bg-color-primary-D"
                      : saltGlassPercent2 <= 10
                      ? `${loadType_5 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_5 && saltGlassPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("glassCleaner", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("glassCleaner", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_5 && saltGlassPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(saltGlassPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} left={23} />
                )}

                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      saltGlassPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {saltGlassPercent2 < 10
                      ? `0${saltGlassPercent2}`
                      : `${saltGlassPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// salt glass  section end /// */}
              {/* /// fuel filter  section strt /// */}
              <div
                className="relative"
                onClick={(e) => {
                  navigate(`/piece-details/${fuelFilterPercent}_filter-petrol`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_6 && fuelFilterPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[1.5vw]`}
                >
                  {PIECES_TITLE["filter-petrol"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_6
                      ? "bg-color-primary-D"
                      : fuelFilterPercent2 <= 10
                      ? `${loadType_6 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_6 && fuelFilterPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("filter-petrol", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("filter-petrol", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_6 && fuelFilterPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(fuelFilterPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} right={22} />
                )}
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      fuelFilterPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {fuelFilterPercent2 < 10
                      ? `0${fuelFilterPercent2}`
                      : `${fuelFilterPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// fuel filter  section end /// */}
            </div>
            <div className="flex items-center justify-between px-[3.773495908115375vw] pt-[0.5vw]">
              {/* /// battery  section start /// */}
              <div
                className="relative"
                onClick={(e) => {
                  navigate(`/piece-details/${batteryPercent}_battery`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_7 && batteryPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] right-[5vw]`}
                >
                  {PIECES_TITLE["battery"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] right-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_7
                      ? "bg-color-primary-D"
                      : batteryPercent2 <= 10
                      ? `${loadType_7 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_7 && batteryPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("battery", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] right-0">
                    {SHOW_PIECES("battery", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_7 && batteryPercent2 <= 10
                    ? SIGMENT_BOX_RIGHT_YELLOW
                    : SIGMENT_BOX_RIGHT_BLUE}
                </div>

                <div
                  className={`absolute top-0 left-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(batteryPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} left={23} />
                )}
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw] top-[20.5%] right-[46%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={`text-[7.546991816230749vw] ${
                      batteryPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {batteryPercent2 < 10
                      ? `0${batteryPercent2}`
                      : `${batteryPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// battery  section end /// */}
              {/* /// radiator   section strt /// */}
              <div
                className="relative"
                onClick={(e) => {
                  navigate(`/piece-details/${radiatorPercent}_radiatorWater`);
                }}
              >
                <span
                  className={`absolute ${
                    !loadType_8 && radiatorPercent2 <= 10
                      ? "text-color-primary-B"
                      : "text-color-primary-D"
                  } font-font_primary_A text-[2.8vw] top-[3.5vw] left-[3.5vw]`}
                >
                  {PIECES_TITLE["radiatorWater"]}
                </span>
                <div
                  className={`absolute w-[7.2vw] h-[0.9vw]  top-[12.8vw] left-[3.2vw] outline-none rounded-[1.8vw]  ${
                    loadType_8
                      ? "bg-color-primary-D"
                      : radiatorPercent2 <= 10
                      ? `${loadType_8 ? "" : "animAlarm"}`
                      : "bg-color-primary-D"
                  } `}
                ></div>
                {!loadType_8 && radiatorPercent2 <= 10 ? (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("radiatorWater", "#FEC42B")}
                  </div>
                ) : (
                  <div className="absolute top-[15.5vw] left-0">
                    {SHOW_PIECES("radiatorWater", "#00FFF2")}
                  </div>
                )}

                <div className="w-[44.95648687530954vw] h-[30.42616919412278vw]">
                  {!loadType_8 && radiatorPercent2 <= 10
                    ? SIGMENT_BOX_LEFT_YELLOW
                    : SIGMENT_BOX_LEFT_BLUE}
                </div>

                <div
                  className={`absolute top-0 right-0 W-[30.42381075918021vw] h-[30.42381075918021vw]  ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  {sigments(radiatorPercent2)}
                </div>
                {isLoadingPercents && (
                  <BlueLoader width={10} top={33.5} right={22} />
                )}
                <div
                  className={`absolute w-[18.16329507799378vw] h-[18.16329507799378vw]  top-[20.5%] right-[14%] flex items-center justify-center rounded-full ${
                    isLoadingPercents ? "hidden" : ""
                  }`}
                >
                  <span
                    className={` text-[7.546991816230749vw] ${
                      radiatorPercent2 <= 10
                        ? "text-color-primary-B"
                        : "text-color-primary-D"
                    } font-font_primary_D `}
                  >
                    {radiatorPercent2 < 10
                      ? `0${radiatorPercent2}`
                      : `${radiatorPercent2}`}
                  </span>
                </div>
              </div>
              {/* /// radiator   section end /// */}
            </div>
          </div>
        </div>

        <Footer forwardRef={footerRef} />
      </div>
    </>
  );
}
